(function () {
  function ensureCartBubbleZero() {
    const bubble = document.querySelector('#cart-icon-bubble');
    if (!bubble) return;

    const hasCount = bubble.querySelector('[aria-hidden="true"]');

    if (!hasCount) {
      bubble.innerHTML = `
      <span class="svg-wrapper">
            <svg class="icon icon-cart-empty" width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_118_2105)">
            <path d="M16.4437 6.20625L16.2937 4.18125C16.125 1.95 14.25 0.1875 12 0.1875C9.74998 0.1875 7.85623 1.95 7.70623 4.18125L7.55623 6.20625H5.39998C4.51873 6.20625 3.78748 6.9 3.71248 7.78125L2.69998 22.0125C2.66248 22.4812 2.83123 22.95 3.14998 23.2875C3.46873 23.625 3.91873 23.8312 4.38748 23.8312H19.6312C20.1 23.8312 20.55 23.6437 20.8687 23.2875C21.1875 22.95 21.3562 22.4812 21.3187 22.0125L20.3062 7.9125C20.2312 6.95625 19.4437 6.225 18.4875 6.225H16.4437V6.20625ZM8.83123 4.25625C8.94373 2.60625 10.3312 1.3125 12 1.3125C13.6687 1.3125 15.0562 2.60625 15.1687 4.25625L15.3 6.20625H8.68123L8.83123 4.25625ZM19.1812 7.9875L20.1937 22.0875C20.2125 22.2375 20.1562 22.3875 20.0437 22.5187C19.9312 22.6312 19.7812 22.7062 19.6312 22.7062H4.38748C4.23748 22.7062 4.08748 22.65 3.97498 22.5187C3.86248 22.3875 3.80623 22.2562 3.82498 22.0875L4.83748 7.85625C4.85623 7.55625 5.09998 7.33125 5.39998 7.33125H7.48123L7.36873 8.83125C7.34998 9.15 7.57498 9.4125 7.89373 9.43125H7.93123C8.23123 9.43125 8.47498 9.20625 8.49373 8.90625L8.60623 7.33125H15.3937L15.5062 8.90625C15.525 9.225 15.7875 9.45 16.1062 9.43125C16.425 9.4125 16.65 9.15 16.6312 8.83125L16.5187 7.33125H18.4875C18.8437 7.33125 19.1437 7.6125 19.1812 7.9875Z" fill="black"></path>
            </g>
            <defs>
            <clipPath id="clip0_118_2105">
            <rect width="24" height="24" fill="white"></rect>
            </clipPath>
            </defs>
            </svg>
          </span>
        <div class="c-cart-count-bubble ttt">
          <span aria-hidden="true">0</span>
          <span class="visually-hidden">(0)</span>
        </div>
      `;
    }
  }

  // Run on page load
  document.addEventListener('DOMContentLoaded', ensureCartBubbleZero);

  // Run after ANY ajax cart update (Dawn standard)
  document.addEventListener('cart:updated', ensureCartBubbleZero);

  // Fallback: mutation observer (covers all edge cases)
  const observer = new MutationObserver(() => {
    ensureCartBubbleZero();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
})();
